// @ts-nocheck
// This file is generated by Umi automatically
// DO NOT CHANGE IT MANUALLY!
import AppstoreOutlined from '/Users/pip/Documents/mcp-web/node_modules/@ant-design/icons/es/icons/AppstoreOutlined';
import ToolOutlined from '/Users/pip/Documents/mcp-web/node_modules/@ant-design/icons/es/icons/ToolOutlined';
export default { AppstoreOutlined, ToolOutlined };
